// tslint:disable:no-console
import { decode } from 'iconv-lite';
import JSZip from 'jszip';
import { streamDecodeToString } from './ReadFile';

export async function getFileListFromZip(zipFile: File): Promise<string[]> {
  return loadAsync(zipFile)
           .then(jsZip => {
             return jsZip.filter((path, file) => !file.dir && !/DS_Store/.test(path))
                      .map(zipObj => zipObj.name)
                      .sort((a, b) => a.localeCompare(b))
           });
}

export async function getFileContentsFromZip(zipFile: File, filename: string): Promise<string> {
  const zipObj = (await loadAsync(zipFile)).file(filename);
  if (!zipObj) {
    return Promise.reject(new Error(`File is not found. filename: ${filename}`));
  }
  return streamDecodeToString(zipObj.nodeStream());
}

async function loadAsync(zipFile: File): Promise<JSZip> {
  return JSZip.loadAsync(zipFile, {
    decodeFileName: filenameBytes => decode(Buffer.from(filenameBytes), "cp932")
  });
}
